export const CITIES_SEARCH_REQUEST = "META:CITIES_SEARCH_REQUEST"
export const CITIES_SEARCH_SUCCESS = "META:CITIES_SEARCH_SUCCESS"
export const CITIES_SEARCH_FAILURE = "META:CITIES_SEARCH_FAILURE"
export const CITIES_SEARCH_SAVE_CANCEL_TOKEN = "META:CITIES_SEARCH_SAVE_CANCEL_TOKEN"
export const CITIES_SEARCH_ABORT = "META:CITIES_SEARCH_ABORT"
export const CITIES_RESET_SEARCH = "META:CITIES_RESET_SEARCH"
